export class UpdateWarrantyServiceModel{
    id : number;
    title : string;
    warrantyServiceTerm : string;
    duration : string;   
    isActive: string;                                                                                           
}


